export function createArray<T extends object>(
  length: number,
  initialValue: T
): T[] {
  return Array.from({ length }, () => initialValue);
}

export const typedKeys = <T extends Record<string, unknown>>(obj?: T) =>
  Object.keys(obj ?? {}) as (keyof T)[];

export const typedEntries = <T extends Record<string, unknown>>(obj?: T) =>
  Object.entries(obj ?? {}) as [keyof T, T[keyof T]][];
